import { getBetDescription, getPrematchAggs, isAsianHandicap, parseHandicap } from "../data/utils";
import BetWrapper from "./BetWrapper";
import OddWithDesc from "./OddWithDesc";
import OddSelector from "./OddSelector";
import { getCustomBetDesc } from "../data/bet-templates/bet-templates";

function getBetDesc(bet) {
    let desc = null;
    try {
        const agg = getPrematchAggs(bet.matchData.sportId, bet.aggId);
        const aggBet = agg.bets.find(b => b.id === bet.id);
        if (aggBet != null) {
            desc = aggBet.desc;
        }
    } catch (e) {
        desc = getBetDescription(bet, true);
    }
    return desc;
}

export default function BetsGroup(props) {
    const bets = props.bets;
    const firstBet = bets[0];
    const desc = getCustomBetDesc(firstBet.odds[0].matchData.sportRef, firstBet.id) || getBetDesc(firstBet);

    return (
        <BetWrapper data={firstBet} desc={desc} toggled={props.toggled}>
            <div className="c_58">
                {(() => {
                    const lines = [];
                    const renderedOdds = bets.map((bet, betIndex) => {
                        const handicapDesc = parseHandicap('', bet.handicap, bet.tipoHandicap, bet.eqs || bet.odds, bet.dia || bet.odds?.[0]?.dia, false, bet.handicapInfo);
                        lines.push(
                            <div key={betIndex}>
                                {isAsianHandicap(bet.cs) ? `+- ${handicapDesc}` : handicapDesc}
                            </div>
                        );

                        if (bet.odds.length > 3) {
                            return (
                                <div key={betIndex} className="c_58_2_1" data-cols={bet.odds.length}>
                                    <OddSelector odds={bet.odds} />
                                </div>
                            );
                        }

                        return (
                            <div key={betIndex} className="c_58_2_1" data-cols={bet.odds.length}>
                                {bet.odds.map((odd, oddIndex) =>
                                    <OddWithDesc key={`${betIndex}_${oddIndex}`} data={odd} desc={odd.desc} betBuilder={props.betBuilder} />
                                )}
                            </div>
                        );
                    });

                    return (
                        <>
                            <div className="c_58_1">
                                {lines}
                            </div>
                            <div className="c_58_2">
                                {renderedOdds}
                            </div>
                        </>
                    );
                })()}
            </div>
        </BetWrapper>
    );
}
